import { FaArrowRight, FaEnvelope } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { contactInfoSection } from '../../data/contactPageData'
import { company, contactCards } from '../../data/siteData'
import { openMailto, openTel } from '../../utils/contactLinks'

function ContactInfoSection() {
  const { label, titleLine1, titleAccent, titleLine2, description } = contactInfoSection

  return (
    <AnimatedSection className="contact-info">
      <div className="container corp-container">
        <div className="row g-4 g-xl-5 align-items-start">
          <div className="col-lg-5">
            <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
            <h2 className="contact-info__title">
              {titleLine1} <span>{titleAccent}</span>
              <br />
              {titleLine2}
            </h2>
            <span className="contact-info__accent" aria-hidden="true" />
            <p className="contact-info__lead">{description}</p>
            <div className="contact-info__actions">
              <a
                className="contact-info__btn contact-info__btn--primary"
                href={company.tel}
                onClick={(event) => openTel(company.phone, event)}
              >
                Call +91 {company.phone}
                <FaArrowRight aria-hidden="true" />
              </a>
              <a
                className="contact-info__btn contact-info__btn--outline"
                href={company.mailto}
                onClick={(event) => openMailto(company.email, event)}
              >
                Email Us
                <FaEnvelope aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="contact-info__grid" role="list">
              {contactCards.map((card) => {
                const Icon = card.icon
                const displayValue =
                  card.linkType === 'phone' ? `+91 ${card.value}` : card.value

                const inner = (
                  <>
                    <span className="contact-info__card-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <div className="contact-info__card-body">
                      <span className="contact-info__card-label">{card.label}</span>
                      <strong className="contact-info__card-value">{displayValue}</strong>
                    </div>
                  </>
                )

                if (card.link) {
                  const handleCardClick =
                    card.linkType === 'email'
                      ? (event) => openMailto(card.value, event)
                      : card.linkType === 'phone'
                        ? (event) => openTel(card.value, event)
                        : undefined

                  return (
                    <a
                      className="contact-info__card contact-info__card--link"
                      key={card.label}
                      href={card.link}
                      onClick={handleCardClick}
                      role="listitem"
                    >
                      {inner}
                    </a>
                  )
                }

                return (
                  <div
                    className="contact-info__card contact-info__card--static"
                    key={card.label}
                    role="listitem"
                  >
                    {inner}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ContactInfoSection
